import React, { memo, useEffect, useState } from "react";
import {
  Stack,
  CircularProgress,
  Chip,
  Divider,
} from "investira.react.components";
import { validators } from "investira.sdk";
import services from "../../../../services";
import { InlineInfo } from "../../../../components/molecules";
import { useEmpresasContext } from "../../../../contexts/EmpresasContext";

const EmpresaSetores = memo((props) => {
  const { state } = useEmpresasContext();
  const [setores, setSetores] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    services.pessoas.setores(
      { pessoa_id: props.pessoaId },
      (rRes) => {
        setSetores(rRes.data);
      },
      (rErr) => {
        console.log(rErr);
      },
      () => {
        setIsLoading(false);
      }
    );
  }, [props.pessoaId]);

  if (isLoading) {
    return (
      <Stack
        justifyContent="center"
        alignItems="center"
        flexGrow={1}
        sx={{ py: 2 }}
      >
        <CircularProgress size={24} />
      </Stack>
    );
  }

  return (
    <Stack direction="column" spacing={2}>
      {/* <Stack direction="row" spacing={2} justifyContent="flex-end">
        {!validators.isEmpty(state.pessoa.setor_id) && (
          <Chip
            key={state.pessoa.setor_id}
            label={`CNAE: ${state.pessoa.setor_id}`}
            size="small"
            color="primary"
          />
        )}
      </Stack>
      <Divider /> */}
      {setores.map((setor, index) => {
        return (
          <InlineInfo
            key={index}
            label={`${setor.top_setor} (CNAE: ${setor.setor_id})`}
            value={`${setor.setor}`}
            searchProps={{
              path: "/empresas",
              search: {
                top_setor_id: setor.top_setor_id,
                setor_id: setor.setor_id,
              },
            }}
          />
        );
      })}
    </Stack>
  );
});

export default EmpresaSetores;
